import getSessionContext from '../context/getSessionContext';
export default function (params) {
    var _a;
    const apiVersion = (params === null || params === void 0 ? void 0 : params.apiVersion) || 0;
    const remoteEntityName = params === null || params === void 0 ? void 0 : params.remoteEntityName;
    const localEntity_operatingMode = (_a = params === null || params === void 0 ? void 0 : params.localEntity_operatingMode) !== null && _a !== void 0 ? _a : 'prefer-remote';
    const fetchAllColumnsWhenFetching = params === null || params === void 0 ? void 0 : params.fetchAllColumnsWhenFetching;
    const repeatLastFetchOnContextOrgIdChange = params === null || params === void 0 ? void 0 : params.repeatLastFetchOnContextOrgIdChange;
    const repeatLastFetchOnContextScopeIntervalChange = params === null || params === void 0 ? void 0 : params.repeatLastFetchOnContextScopeIntervalChange;
    const defaultRecordCardComponent = params === null || params === void 0 ? void 0 : params.defaultRecordCardComponent;
    const defaultListComponent = params === null || params === void 0 ? void 0 : params.defaultListComponent;
    return {
        apiVersion: () => apiVersion,
        remoteEntityName: () => remoteEntityName,
        localEntity_operatingMode: () => localEntity_operatingMode,
        fetchAllColumnsWhenFetching: () => fetchAllColumnsWhenFetching,
        repeatLastFetchOnContextOrgIdChange: () => Boolean(repeatLastFetchOnContextOrgIdChange),
        repeatLastFetchOnContextScopeIntervalChange: () => Boolean(repeatLastFetchOnContextScopeIntervalChange),
        defaultRecordCardComponent: () => defaultRecordCardComponent,
        defaultListComponent: () => defaultListComponent,
        controllers: () => {
            return {
                get create() {
                    if (apiVersion === 1) {
                        return 'generic_controllers.rpc';
                    }
                    else {
                        return (params === null || params === void 0 ? void 0 : params.createControllerName) || remoteEntityName + '_create';
                    }
                },
                get fetch() {
                    if (apiVersion === 1) {
                        return 'generic_controllers.rpc';
                    }
                    else {
                        return (params === null || params === void 0 ? void 0 : params.fetchControllerName) || remoteEntityName + '_fetch';
                    }
                },
                get update() {
                    if (apiVersion === 1) {
                        return 'generic_controllers.rpc';
                    }
                    else {
                        return (params === null || params === void 0 ? void 0 : params.updateControllerName) || remoteEntityName + '_update';
                    }
                },
                get delete() {
                    if (apiVersion === 1) {
                        return 'generic_controllers.rpc';
                    }
                    else {
                        return (params === null || params === void 0 ? void 0 : params.deleteControllerName) || remoteEntityName + '_delete';
                    }
                }
            };
        },
        controllerDefaultParamsCommonForAllModules: (state, getters, rootState) => {
            const sessionContext = getSessionContext();
            if (apiVersion !== 1) {
                console.warn(`controllerDefaultParamsCommonForAllModules is permanently implemented only for apiVersion 1. apiVersion 0 impelementation will be removed. Consider moving entity ${remoteEntityName} to apiVersion 1`);
            }
            const commonParamsWithContext = apiVersion === 1
                ? {
                    context: sessionContext,
                    api_version: apiVersion,
                    entity: remoteEntityName,
                    fetchAllColumnsWhenFetching: fetchAllColumnsWhenFetching
                }
                : Object.assign({}, sessionContext);
            return {
                fetch: Object.assign(Object.assign({ action: 'select' }, commonParamsWithContext), { pagination: state.pagination }),
                create: Object.assign({ action: 'insert' }, commonParamsWithContext),
                update: Object.assign({ action: 'update' }, commonParamsWithContext),
                delete: Object.assign({ action: 'delete' }, commonParamsWithContext)
            };
        },
        /** @depricated Use getCurrentRecord */
        currentObj: (state) => ((state === null || state === void 0 ? void 0 : state.list) || []).find((r) => r.id === state.current),
        nextId: (state) => (increment) => {
            var _a, _b;
            if (!increment)
                increment = 1;
            const idx = state === null || state === void 0 ? void 0 : state.list.findIndex((r) => r.id === state.current);
            const newIdx = Math.max(0, Math.min(((_a = state === null || state === void 0 ? void 0 : state.list) === null || _a === void 0 ? void 0 : _a.length) - 1, idx + increment));
            return (_b = state === null || state === void 0 ? void 0 : state.list[newIdx]) === null || _b === void 0 ? void 0 : _b.id;
        },
        /** @depricated Use getCurrentRecord */
        beingViewedObj: (state) => ((state === null || state === void 0 ? void 0 : state.list) || []).find((r) => r.id === state.beingViewed),
        getObjectById: (state) => (id) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.list) === null || _a === void 0 ? void 0 : _a.find((r) => r.id === id); },
        getReferencedObjectByReferencingObjectIdAndColumnName: (state, getters, rootState, rootGetters) => (id, referencingColumnName, referencedField = 'id') => {
            var _a;
            const referencingColumn = (_a = getters.columns) === null || _a === void 0 ? void 0 : _a.find((col) => col.name === referencingColumnName);
            const referencingObject = getters.getObjectById(id);
            const referencedList = referencingColumn.references || referencingColumn.complexlyReferences;
            const referencedObject = referencedList === null || referencedList === void 0 ? void 0 : referencedList.find((r) => r[referencedField] === referencingObject[referencingColumn.field]);
            return referencedObject;
        }
    };
}
